export const productLines = ['all', 'Bazar Premium', 'Combos', 'Complementos', 'Contemporánea', 'Contemporánea Cera Forte Terra', 'Ediciones especiales', 'Electro', 'Fusion', 'Inducción', 'Nuit', 'Repuestos'];
